export default "__VITE_ASSET__CuRjddPw__"